import {Navigate} from "react-router-dom";

import {useGetHasPermissions} from "../store/me";

export default function PermissionGuard({
  permission,
  children,
}: {
  permission: string;
  children: React.ReactNode;
}) {
  const getHasPermission = useGetHasPermissions();
  const hasPermission = getHasPermission(permission);

  if (!hasPermission) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}
